import { Controller } from "@hotwired/stimulus";
import { parse } from "smtp-address-parser";
import { startCase, camelCase, throttle } from "lodash";

window.emailParse = parse;
const $ = window.jQuery;

export default class extends Controller {
  static targets = ["email", "name", "company", "logo", "logoSrc"];

  static values = { host: String };

  showUrlPreview(element) {
    if (element.value === "") {
      $("#hint").addClass("hidden");
    } else {
      $("#hint").removeClass("hidden");
    }

    let html = element.value
      .toLowerCase()
      .replace(/(https?:\/\/|www\.|\.com)/g, "")
      .replace(/\W+/g, "-")
      .toLowerCase();
    html = `Your sign in URL will be:<br /><strong>https://${html}.${this.hostValue}</strong>`;

    document.querySelector("#hint").innerHTML = html;
  }

  initUrlPreview() {
    const $this = this;
    var tenantName = document.querySelector("#tenant_name");
    tenantName.addEventListener("keyup", function (e) {
      $this.showUrlPreview(e.target);
    });
    $this.showUrlPreview(tenantName);

    var registerButton = document.querySelector("#registerButton");
    registerButton.addEventListener("click", function () {
      var tenant_name = document.getElementById("tenant_name").value;
      var regexp = /^[a-z](?:[a-z0-9-]*[a-z0-9])?$/;
      regexp.exec(tenant_name);
    });
  }

  parseEmail(e) {
    if (e.target.value) {
      try {
        var parsed = parse(e.target.value);
      } catch (error) {
        console.log(error);
      }
    }

    if (parsed) {
      var [company, tld] = parsed.domainPart.DomainName.split(".");

      if (!tld || tld.length < 2) {
        return false;
      }

      // Skip free email providers (synced with CompanyNameGuesserService::FREE_EMAIL_PROVIDERS)
      const freeEmailProviders = [
        "gmail",
        "yahoo",
        "hotmail",
        "aol",
        "outlook",
        "icloud",
        "protonmail",
        "mail",
        "ymail",
        "live",
        "msn",
      ];
      if (freeEmailProviders.includes(company)) {
        return false;
      }

      var fullName = parsed.localPart.DotString.replace(/\W+/g, " ")
        .replace(/\d+/, "")
        .trim();
      if (fullName.split(" ").length > 1) {
        this.nameTarget.value = startCase(
          camelCase(
            parsed.localPart.DotString.replace(/\W+/g, " ").replace(/\d+/, "")
          )
        );
      }

      // Set initial company name from simple parsing (instant feedback)
      this.companyTarget.value = startCase(camelCase(company));

      this.nameTarget.closest(".field").classList.remove("hidden");
      this.companyTarget.closest(".field").classList.remove("hidden");

      if (parsed.domainPart.DomainName != this.logoTarget.src) {
        const token = "pk_E_Fx0-7gSceC_0F8wOoxLw";
        this.logoTarget.src = `https://img.logo.dev/${parsed.domainPart.DomainName}?token=${token}`;
        this.logoSrcTarget.value = `https://img.logo.dev/${parsed.domainPart.DomainName}?token=${token}`;
      }

      this.showUrlPreview(this.companyTarget);

      // Call backend to get a better AI-powered company name guess
      this.fetchBetterCompanyName(parsed.domainPart.DomainName);
    } else {
      this.nameTarget.value = "";
      this.companyTarget.value = "";
      this.showUrlPreview(this.companyTarget);
      this.logoTarget.src = "";
      this.logoSrcTarget.value = "";
    }
  }

  async fetchBetterCompanyName(domain) {
    // Skip if we've already fetched for this domain
    if (this.lastFetchedDomain === domain) {
      return;
    }
    this.lastFetchedDomain = domain;

    try {
      const response = await fetch(
        `/guess_company_name?domain=${encodeURIComponent(domain)}`
      );
      if (!response.ok) {
        return;
      }

      const data = await response.json();
      if (data.name && data.name.trim() !== "") {
        // Only update if the user hasn't manually changed the field
        const currentValue = this.companyTarget.value;
        const simpleParsedName = startCase(camelCase(domain.split(".")[0]));

        if (currentValue === simpleParsedName) {
          this.companyTarget.value = data.name;
          this.showUrlPreview(this.companyTarget);
        }
      }
    } catch (error) {
      // Silently fail - the simple parsed name will remain
      console.log("Company name lookup failed:", error);
    }
  }

  logoDevError() {
    $(".logo-dev").hide();
  }

  initValidation() {
    $("#new_brand").form({
      inline: true,
      errorFocus: false,
      on: "blur",
      fields: {
        name: {
          identifier: "Full name",
          rules: [
            {
              type: "empty",
              prompt: "Please enter your name",
            },
          ],
        },
        email: {
          identifier: "Work email",
          rules: [{ type: "empty" }, { type: "email" }],
        },
        password: {
          identifier: "Password",
          rules: [{ type: "empty" }, { type: "minLength[8]" }],
        },
        tos: {
          rules: [
            {
              type: "checked",
              prompt: "You must accept our terms",
            },
          ],
        },
      },
    });
  }

  initialize() {
    this.parseEmail = throttle(this.parseEmail, 200);
  }

  connect() {
    this.initValidation();
    this.initUrlPreview();
  }
}
